// Archivo: src/components/ui/StockCounter.jsx

import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const StockCounter = ({ 
  initialStock = 3000, 
  variant = 'default', 
  showProgress = true,
  maxStock = 5000,
  className = '' 
}) => {
  const [currentStock, setCurrentStock] = useState(initialStock);
  const [isUpdating, setIsUpdating] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  useEffect(() => {
    // Simulate real-time stock updates
    const interval = setInterval(() => {
      setIsUpdating(true);
      
      setTimeout(() => {
        setCurrentStock(prev => {
          const decrease = Math.floor(Math.random() * 3);
          const newStock = Math.max(0, prev - decrease);
          setLastUpdate(new Date());
          return newStock;
        });
        setIsUpdating(false);
      }, 500);
    }, 25000 + Math.random() * 10000); // Random interval between 25-35 seconds

    return () => clearInterval(interval);
  }, []);

  const stockPercentage = (currentStock / maxStock) * 100;
  const isLowStock = stockPercentage < 20;
  const isCriticalStock = stockPercentage < 10;

  const getStockStatus = () => {
    if (isCriticalStock) return { color: 'text-error', bg: 'bg-error/10', label: '¡Últimos boletos!' };
    if (isLowStock) return { color: 'text-warning', bg: 'bg-warning/10', label: 'Stock limitado' };
    return { color: 'text-success', bg: 'bg-success/10', label: 'Disponible' };
  };

  const status = getStockStatus();

  if (variant === 'compact') {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <div className={`w-2 h-2 rounded-full ${isUpdating ? 'animate-golden-pulse' : ''} ${
          isCriticalStock ? 'bg-error' : isLowStock ? 'bg-warning' : 'bg-success'
        }`} />
        {/* Usamos text-foreground aquí porque este componente compacto puede estar sobre fondo oscuro */}
        <span className="font-mono text-sm text-foreground">
          {currentStock?.toLocaleString()}
        </span>
      </div>
    );
  }

  if (variant === 'minimal') {
    return (
      <div className={`flex items-center space-x-1 ${className}`}>
        <Icon name="Clock" size={12} className="text-secondary" />
        {/* Corregido: text-text-secondary a text-foreground (para que se vea si está sobre oscuro) */}
        <span className="font-mono text-xs text-foreground">
          {currentStock?.toLocaleString()}
        </span>
      </div>
    );
  }

  return (
    <div className={`bg-card rounded-xl border border-border p-4 shadow-luxury ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <div className={`p-2 rounded-lg ${status?.bg}`}>
            <Icon 
              name={isUpdating ? "RefreshCw" : "Clock"} 
              size={16} 
              className={`${status?.color} ${isUpdating ? 'animate-spin' : ''}`} 
            />
          </div>
          <div>
            {/* CORRECCIÓN: text-card-foreground -> text-black */}
            <h3 className="font-body font-semibold text-black">Boletos Disponibles</h3>
            {/* Este texto usa un color de estado (error/warning/success), se ve bien */}
            <p className={`text-xs font-caption ${status?.color}`}>{status?.label}</p>
          </div>
        </div>
        
        <div className="text-right">
            {/* CORRECCIÓN: text-card-foreground -> text-black */}
          <div className="font-mono text-2xl font-bold text-black">
            {currentStock?.toLocaleString()}
          </div>
          {/* CORRECCIÓN: text-muted-foreground -> text-black */}
          <div className="text-xs text-black font-caption">
            de {maxStock?.toLocaleString()}
          </div>
        </div>
      </div>
      {showProgress && (
        <div className="space-y-2">
          <div className="flex justify-between text-xs font-caption">
            {/* CORRECCIÓN: text-muted-foreground -> text-black */}
            <span className="text-black">Progreso de venta</span>
            {/* Este texto usa un color de estado (error/warning/success), se ve bien */}
            <span className={status?.color}>{Math.round(100 - stockPercentage)}% vendido</span>
          </div>
          
          <div className="w-full bg-muted/30 rounded-full h-2 overflow-hidden">
            <div 
              className={`h-full transition-all duration-1000 ease-out ${
                isCriticalStock ? 'bg-error' : isLowStock ?'bg-warning': 'bg-gradient-to-r from-secondary to-success'
              }`}
              style={{ width: `${100 - stockPercentage}%` }}
            />
          </div>
        </div>
      )}
      {/* Footer de Actualización */}
      <div className="mt-3 pt-3 border-t border-border flex items-center justify-between text-xs font-caption">
        <div className="flex items-center space-x-1">
          {/* CORRECCIÓN: Ícono y texto de "Actualizado" (text-muted-foreground -> text-black) */}
          <Icon name="RefreshCw" size={10} className="text-black" />
          <span className="text-black">Actualizado</span>
        </div>
        {/* CORRECCIÓN: Hora de actualización (text-muted-foreground -> text-black) */}
        <span className="text-black">{lastUpdate?.toLocaleTimeString('es-VE', { 
          hour: '2-digit', 
          minute: '2-digit' 
        })}</span>
      </div>
    </div>
  );
};

export default StockCounter;